export const FETCH_BUILDINGS = "FETCH_BUILDINGS"
export const GET_BUILDING = "GET_BUILDING"
export const CREATE_BUILDING = "CREATE_BUILDING"
export const UPDATE_BUILDING = "UPDATE_BUILDING"
export const DELETE_BUILDING = "DELETE_BUILDING"
export const FLAT_BY_BUILDING = "FLAT_BY_BUILDING"